import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { Section, Text } from "@jewlr/storybook/info"

import {
  sizeChart as getSizeChart,
  averageRingSize as getAverageRingSize,
} from "./data"

const Table = styled.table`
  thead tr {
    vertical-align: baseline;
  }
  border-collapse: collapse;
  width: 100%;
`

const ChartTableData = styled(Box).attrs((props) => ({
  as: "tr",
  fontSize: { _: "14px", tablet: "16px" },
  ...props,
}))`
  text-align: center;
  :nth-child(even) {
    background-color: ${(props) => props.theme.colors.grey[5]};
  }
`

const Td = styled(Box).attrs({
  as: "td",
})`
  width: 33%;
  height: 45px;
`

const VerticalSizeChart = () => {
  const sizeChart = getSizeChart()
  const averageRingSize = getAverageRingSize()
  return (
    <Box>
      <Box contain pb={5}>
        <Box mx={{ _: 2, tablet: 8 }}>
          <Table>
            <thead>
              <ChartTableData mb={1}>
                <Td>RING SIZE</Td>
                <Td>DIAMETER (mm)</Td>
                <Td>CIRCUMFERENCE (mm)</Td>
              </ChartTableData>
            </thead>
            <tbody>
              {sizeChart.map((size, i) => (
                <ChartTableData border key={`size${i}`}>
                  <Td>{size.size}</Td>
                  <Td>{size.diameter}</Td>
                  <Td>{size.circumference}</Td>
                </ChartTableData>
              ))}
            </tbody>
          </Table>
        </Box>
      </Box>
      <Section hasBg pt={1}>
        <Box contain textAlign="left">
          <Box mx={8}>
            <Text color="primary">PLEASE NOTE:</Text>
            <Text>
              The average ring size for women is size {averageRingSize.women};
              the average ring size for men is size {averageRingSize.men}
              .
              <br />A ring should fit secure enough so that it will never fall
              off. It should have a loose comfortable fit when sliding it over
              your knuckle.
            </Text>
          </Box>
        </Box>
      </Section>
    </Box>
  )
}
VerticalSizeChart.propTypes = {
  averageRingSize: PropTypes.object,
  sizeChart: PropTypes.array,
}

export default VerticalSizeChart
